import { render, staticRenderFns } from "./MakeComplaintDialog.vue?vue&type=template&id=49057de8"
import script from "./MakeComplaintDialog.vue?vue&type=script&lang=ts"
export * from "./MakeComplaintDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports